import { AMSCountryType, MercuryCountryType } from "app/types/countryType";
import { SUPPORTEDLANGUAGES } from "app/utils/const";
import countryList from "./countryList";
export class CountryHelper {
  static getCountryCode(countryName: string): any | string {
    const country = countryList.find(
      item =>
        item.countryName.toLowerCase() === countryName.trim().toLowerCase()
    );

    if (country != null) {
      return country.countryCode;
    } else {
      // fallback to World flag
      return "WW";
    }
  }

  static getCountryName(countryCode: string): any | string {
    const country = countryList.find(item => {
      return (
        item.countryCode.toLowerCase() === countryCode.trim().toLowerCase()
      );
    });

    if (country != null) {
      return country.countryName;
    } else {
      // fallback to original code
      return countryCode;
    }
  }

  static getCountryCodeForFlagFromLocale(locale: string): any | string {
    if (!locale) {
      return;
    }
    const foundLanguage = SUPPORTEDLANGUAGES.find(
      language => language.locale === locale
    );
    const flagValue = foundLanguage ? foundLanguage.flag : null;
    return flagValue || "";
  }

  // For the direct registration form, the list of countries needs to be fetched from AMS,
  // because it is not  available in mercury.
  // So response needs to be formatted with same structure for countries that is be used 3et.
  static formatCountriesFor3et = (
    countries: AMSCountryType[]
  ): MercuryCountryType[] => {
    return countries.map((country: AMSCountryType) => {
      return {
        code: country["country-code"],
        id: country.id,
        name: country["country-name"],
      };
    });
  };
}
